import type { CustomElement } from "./utils";

/*                                                                        */
export const extendElementAsFormAssociated = (
  Base: CustomElement,
): CustomElement<{
  /**
 *
 */
  internals: ElementInternals;
  /**
 *
 */
  readonly form: HTMLFormElement | null;
}> =>
  class extends Base {
    static formAssociated = true;

    internals: ElementInternals;

    constructor() {
      super();
      /*                                       */
      this.internals = this.attachInternals() as unknown as ElementInternals;
    }

    get form(): HTMLFormElement | null {
      return this.internals.form;
    }

    set form(value: unknown) {
      if (typeof value === "string") {
        this.setAttribute("form", value);
      }
    }

    formResetCallback(): void {
      this.resetForm?.();
    }
  };
